import { saveVideoAPI, unsaveVideoAPI, enableVideoSaver } from './utils';
export class VideoSaver {
    constructor(epConfig) {
      this.epConfig = Object.assign({}, epConfig, { isSaved: false });
      this.saveIcon = null;
      this.toolBarVideoSaver = null;
      this.toolBarVideoSaverBtm = null;
      this.isNowPlaying = !epConfig.isPlaylist;
      this.shareBarSaveToolTip = null;
      this.playListSaveToolTip = null;
    }

    init() {
        if(enableVideoSaver()) {
            this.saveIcon = this.saveIconEl;
            this.saveIcon.addEventListener("click", this.handleClick.bind(this));
            this.updateSaveIconState();
            if(this.isNowPlaying){
                if((typeof this.epConfig.link) == "undefined") { 
                    this.epConfig.link = window.location.pathname; 
                }
                this.addToToolBar();
            }
        }
    }
    handleOrientationChange () {
        if(window.savedData.savedCount === 0) {
            this.addArrowPosTooltip();
            this.positionTooltip();
        }
    };
    addToToolBar() {
        if(enableVideoSaver()) {
            this.toolBarVideoSaver = this.saveIconEl;
            this.toolBarVideoSaverBtm = this.saveIconEl;
            const toolbarEl = document.querySelector(".toolbar .action-items");
            const toolbarElBottom = document.querySelector(".article-content-wrapper .js-toolbar");
            const hasVideoSaver = toolbarEl.querySelector('.save-icon');
            const hasVideoSaverBtm = toolbarElBottom.querySelector('.save-icon');
            if (hasVideoSaver && hasVideoSaver !== null) {
                toolbarEl.removeChild(hasVideoSaver);
            }
            if(hasVideoSaverBtm && hasVideoSaverBtm !== null) {
                toolbarElBottom.removeChild(hasVideoSaverBtm);
            }
            toolbarEl.appendChild(this.toolBarVideoSaver);
            
            this.toolBarVideoSaver.addEventListener('click',this.handleClick.bind(this));
            if(!window._isODP) {
                toolbarElBottom.appendChild(this.toolBarVideoSaverBtm);
                this.toolBarVideoSaverBtm.addEventListener('click',this.handleClick.bind(this));
            }
            this.updatePlayingItem();
            this.addSaveTooltip();
        }
    }
    handleClick(e) {
        console.log('onSave Clicked');
        const preventClick = (event) =>{
            event.stopPropagation();
            event.preventDefault();
        }
        e.target.addEventListener('click', preventClick, { once: true });
        const { link, playlist } = this.epConfig;
        const { title, thumbnail } = playlist;

        this.epConfig.isSaved ? this.unsave(this.epConfig.userTxnId, e.target, preventClick) : this.save({ link, title, thumbnail }, e.target, preventClick);
    }
    
    updateSaveIconState() {
        const savedItem = window.savedData.savedVideos.find(video => video.articleId === this.getArticleId(this.epConfig.link));
        if(savedItem) {
          this.epConfig.isSaved = savedItem.isSaved;
          this.epConfig.userTxnId = savedItem.userTxnId;
        }
        this.updateSaveIcon();

    }

    updateSaveIcon(){
      this.saveIcon.classList.toggle('saved', this.epConfig.isSaved);
      this.updatePlayingItem();
    }

    updatePlayingItem(){
        if(this.isNowPlaying && this.toolBarVideoSaver !== null) {
            this.toolBarVideoSaver.classList.toggle('saved', this.epConfig.isSaved);
            this.toolBarVideoSaverBtm.classList.toggle('saved', this.epConfig.isSaved);
        }
    }

    getArticleId(link) {
        return link ? link.split("/").pop() : location.pathname.split("/").pop();
    }

    save(config, el, preventClick) {
      const payload = this.createPayload(config);
      wmdPageLink('saved-video_save',el);
      saveVideoAPI(payload)
        .then(res => {
            this.handleSaveResponse(res, payload)
            el.removeEventListener('click', preventClick); 
        })
        .catch(error => {
            el.removeEventListener('click', preventClick); 
            console.error('Error saving video:', error)
        });
    }
  
    createPayload(config) {
        return {
            title: config.title,
            url: `${window.origin}${config.link}`,
            articleId: this.getArticleId(config.link),
            thumbnail: config.thumbnail
        };
    }
    
    handleSaveResponse(res, payload) {
        if (res.errorCode === 0 && res.status === 1) {
            this.epConfig.userTxnId = res.additionalInfo.dbresult[0];
            this.epConfig.isSaved = true;
            this.updateSaveIcon();
            this.addSavedVideo(payload);
        }
    }

    addSavedVideo(payload) {
        const savedItem = this.createSavedItem(payload);
        window.savedData.savedVideos.push(savedItem);
        window.savedData.savedCount = (window.savedData.savedCount || 0) + 1;
        this.updatefabButtonCount();
    }
    
    createSavedItem(payload) {
        return {
            articleId: payload.articleId,
            title: payload.title,
            userTxnId: this.epConfig.userTxnId,
            link: payload.url,
            isSaved: true,
        };
    }

    unsave(userTxnId, el, preventClick) {
      wmdPageLink('saved-video_unsave',el);
      unsaveVideoAPI(userTxnId)
        .then(res => {
            this.handleUnsaveResponse(res, userTxnId)
            el.removeEventListener('click', preventClick);
        })
        .catch(error => {
            console.error('Error unsaving video:', error)
            el.removeEventListener('click', preventClick);
        });
    }
  
    handleUnsaveResponse(res, userTxnId) {
        if (res.errorCode === 0 && res.status === 1) {
            this.epConfig.isSaved = false;
            this.updateSaveIcon();
            this.removeSavedVideo(userTxnId);
            this.updatefabButtonCount();
        }
    }
    
    removeSavedVideo(userTxnId) {
        window.savedData.savedVideos = window.savedData.savedVideos.filter(video => video.userTxnId !== userTxnId);
        window.savedData.savedCount--;
    }
    updatefabButtonCount(){
      const fabButtonEl = document.getElementById("fab-button-watchlist");
      if(fabButtonEl){
        const savedCountEl = fabButtonEl.querySelector(".saved-count");
        const savedCount = window.savedData.savedCount || 0;
        fabButtonEl.classList.toggle('show', savedCount > 0);
        savedCountEl.textContent = savedCount;
      }
    }

    addSaveTooltip() {
        const savedCount = window.savedData.savedCount;
        if (savedCount === 0) {
            const shareBarEl = document.querySelector(".toolbar .action-items");
            const isTooltipExists = shareBarEl.querySelector(".save-tooltip");

            if (!isTooltipExists) {
                this.shareBarSaveToolTip = this.saveTooltipEl;
                shareBarEl.append(this.shareBarSaveToolTip);
                this.shareBarSaveToolTip.classList.add('sharebar');
                this.addArrowPosTooltip();
                this.activeToolTip(this.shareBarSaveToolTip);
            }

            setTimeout(() => {
                this.positionTooltip();
                const isTooltipExists = document.querySelector('.save-tooltip.playlist');
                if(isTooltipExists) {
                    this.activeToolTip(isTooltipExists);
                }
            }, 1000);
            window.addEventListener('resize', this.handleOrientationChange.bind(this));
            window.addEventListener('orientationchange',this.handleOrientationChange.bind(this));
            window.addEventListener('scroll',this.handleOrientationChange.bind(this));
        }
    }

    positionTooltip() {
        try {
            const playListContainer = document.querySelector(window._isODP ? '.filmStrip' : '.playlist-container');
    
            if (playListContainer) {
                const isPlaylistTooltipExists = document.querySelector('.save-tooltip.playlist');
                if (!isPlaylistTooltipExists) {
                    this.playListSaveToolTip = this.saveTooltipEl;
                    document.body.append(this.playListSaveToolTip);
                    this.playListSaveToolTip.classList.add('playlist');
                }
                const saveIcon = playListContainer.querySelector('.is-selected .save-icon') || this.saveIcon;
                const saveIconRect = saveIcon.getBoundingClientRect();
                const saveTooltipEl = document.querySelector('.save-tooltip.playlist');
                const saveTooltipRect = saveTooltipEl.getBoundingClientRect()
                const tooltipX = saveTooltipRect.width / 2;
                const tooltipY = saveTooltipRect.height / 2;
    
                saveTooltipEl.style.left = `${saveIconRect.left + window.scrollX + (saveIconRect.left < tooltipX ? 30 : 10 - tooltipX)}px`;
                saveTooltipEl.style.top = `${saveIconRect.bottom + window.scrollY + 10 +(saveIconRect.left < tooltipX ? (- tooltipY - 20) : 0)}px`;
                saveTooltipEl.classList.toggle('left', saveIconRect.left < tooltipX);
            }
        } catch (err) {
            console.log(err);
        }
    
    }
    activeToolTip(el) {
        el.classList.remove('fadeout');
        setTimeout(() => {
            el.classList.add('fadeout');
        }, 5000);
    }
    addArrowPosTooltip(){
        const toolTip = this.shareBarSaveToolTip;
        if (window._isODP) {
            const saveIcon = document.querySelector(".toolbar .action-items .save-icon");
            const widthClass = window.innerWidth < 768 ? 'right' : 'left';
            toolTip.classList.toggle('right', widthClass === 'right');
            toolTip.classList.toggle('left', widthClass === 'left');
            if(widthClass === 'right') {
                toolTip.style.right = `${saveIcon.offsetWidth + 20 }px`;
                toolTip.style.left = 'auto';
                toolTip.style.top = `${saveIcon.offsetTop - 10}px`;
            } else if(widthClass === 'left') {
                toolTip.style.left = `${saveIcon.offsetLeft + saveIcon.offsetWidth - 5}px`;
                toolTip.style.right = 'auto';
                toolTip.style.top = `${saveIcon.offsetTop - 10}px`;
            }
            
        } else {
            if (toolTip) {
                const tooltipX =  toolTip.offsetWidth / 2;
                const saveIcon = document.querySelector(".toolbar .action-items .save-icon");
                toolTip.style.left = `${saveIcon.offsetLeft + 9 - tooltipX}px`;
            }
        }
    }

    get saveIconEl() {
        const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.setAttribute('width', '16');
        svg.setAttribute('height', '24');
        svg.setAttribute('viewBox', '0 -2 16 28');
        svg.setAttribute('fill', 'none');
        const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        path.setAttribute('d', 'M2 0C1.17157 0 0.5 0.671574 0.5 1.5V21.8486C0.5 23.0467 1.83522 23.7612 2.83205 23.0967L8 19.6514L13.1679 23.0967C14.1648 23.7612 15.5 23.0467 15.5 21.8486V1.5C15.5 0.671573 14.8284 0 14 0H2Z');
        svg.appendChild(path);

        const wrapper = document.createElement('div');
        wrapper.classList.add('save-icon');
        wrapper.appendChild(svg);
        return wrapper;
    }

    get saveTooltipEl(){
        const el = document.createElement('span');
        el.classList.add('save-tooltip','fadeout');
        el.innerText = 'New: Save to Watch List';
        return el;
    }
  }
  